const canvas = document.createElement('canvas');
const context = canvas.getContext('2d');
const DEFAULT_FONT_FAMILY = 'Roboto, Helvetica, Arial, sans-serif';
export function measureText(theme, text, variant) {
    const typography = theme.typography[variant];
    const fontSize = getFontSizeInPixels(typography.fontSize ?? theme.typography.fontSize, theme);
    if (context) {
        const { letterSpacing } = typography;
        const fontWeight = typography.fontWeight ?? 400;
        context.font = `${fontWeight} ${fontSize}px ${getCurrentThemeFontFamily(theme)}`;
        context.letterSpacing =
            typeof letterSpacing === 'number'
                ? `${letterSpacing}px`
                : (letterSpacing ?? '0px');
        return Math.ceil(context.measureText(text).width);
    }
    return 0;
}
function getCurrentThemeFontFamily(theme) {
    const themeFontFamily = theme?.typography?.fontFamily;
    if (themeFontFamily) {
        return themeFontFamily;
    }
    return DEFAULT_FONT_FAMILY;
}
function getFontSizeInPixels(fontSize, theme) {
    if (typeof fontSize === 'number') {
        return fontSize;
    }
    const value = parseFloat(fontSize);
    if (fontSize.endsWith('rem')) {
        return value * theme.typography.htmlFontSize;
    }
    if (fontSize.endsWith('em')) {
        return value * theme.typography.fontSize;
    }
    return value;
}
